var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 130,
    viewBox: "0 0 93 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2657 11.06C14.1585 18.1617 10.2554 27.5918 10.2554 37.6622C10.2554 58.3852 27.1495 75.208 47.8885 75.208C57.9085 75.208 67.3459 71.3079 74.4531 64.2062C81.5603 57.1045 85.4634 47.6744 85.4634 37.604C85.4634 16.8811 68.5693 0 47.8303 0C37.8103 0 28.3729 3.9001 21.2074 11.0018L21.2657 11.06ZM75.5017 37.604C75.5017 44.9967 72.6472 51.9238 67.4042 57.1628C62.1611 62.4017 55.2287 65.254 47.8885 65.254C32.6255 65.254 20.2171 52.8552 20.2171 37.604C20.2171 30.2113 23.0716 23.2842 28.3146 18.0453C33.5576 12.8063 40.49 9.954 47.8885 9.954C63.1515 9.954 75.5599 22.3528 75.5599 37.604H75.5017Z",
    fill: "#2E7161"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7911 76.5506C72.0422 75.0009 69.4471 74.8901 67.5854 76.2738C67.3597 76.4399 45.9784 92.2137 26.0638 76.2738C24.2585 74.8348 21.607 74.8348 19.8582 76.3845C19.0683 77.0487 0.451322 93.3206 0 125.145C0 126.418 0.507737 127.636 1.41038 128.521C2.31302 129.407 3.55416 129.905 4.85171 129.905H87.5C90.0951 129.905 92.2389 127.857 92.2953 125.311C92.2953 124.038 93.1415 93.8741 73.7911 76.4952V76.5506ZM9.87266 120.496C11.3395 102.453 19.3504 91.1067 23.5816 86.2362C40.9574 97.5823 59.6309 92.2137 69.8984 86.1255C79.7147 97.0288 81.9713 112.747 82.5355 120.496H9.87266Z",
    fill: "#2E7161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.1a148ab18cf59b7e15e422ceae5eb490.svg";
export { ForwardRef as ReactComponent };